export const CompanyProfileQueryKeys = {
    all: ['company-profile'] as const,
    list: () => [...CompanyProfileQueryKeys.all] as const,
    detail: (profileId: number) => [...CompanyProfileQueryKeys.list(), profileId] as const,
}